import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import type {
  PreparedFieldInsertion,
  SchemaPromptContext
} from '@cli-types/next-adapter/commands.js'
import { applySlotToField } from '@core-engine/schema/add-field/apply-slot-to-field.js'
import { buildPlacementTargets } from '@core-engine/schema/add-field/build-placement-targets.js'
import { promptField } from './prompt-field.js'
import { promptInsertionOrder } from './prompt-insertion-order.js'
import { promptSchemaIntegrationOptions } from './prompt-schema-integration-options.js'
import { promptSelectValue } from './prompt-select-value.js'

export async function createInteractiveInsertion(
  context: SchemaPromptContext,
  loaded: LoadedAuthoredGeneratedSchema,
  schemasDir: string
): Promise<PreparedFieldInsertion> {
  const targets = buildPlacementTargets(loaded)
  const target =
    targets.length === 1
      ? targets[0]!
      : await promptSelectValue(
          context,
          'Where should the new field be inserted?',
          targets.map((candidate) => ({
            value: candidate.id,
            label:
              candidate.scope === 'list-item'
                ? `${candidate.label} (list item scope)`
                : candidate.label
          }))
        ).then((targetId) => targets.find((candidate) => candidate.id === targetId) ?? targets[0]!)

  const order = await promptInsertionOrder(context, target)
  let field = await promptField(context, loaded.kind, schemasDir, target.scope)
  if (loaded.kind !== 'form' && target.id === 'root:fields') {
    const slot = await promptSelectValue(
      context,
      'Field slot',
      [
        { value: 'main', label: 'main' },
        { value: 'sidebar', label: 'sidebar' }
      ],
      'main'
    )
    field = applySlotToField(loaded, target, field, slot)
  }
  const summary = await promptSchemaIntegrationOptions(context, loaded, field, target)

  return {
    field,
    target,
    order,
    summary
  }
}
